import type * as Flows from '../../../shared/domain/flows/types.no-deps'

/**
 * Toggles a choice selection whilst keeping the ordering
 */
export function choiceToggle(choices: Array<{ id: Flows.ChoiceId }>, selection: Flows.ChoiceId[], id: Flows.ChoiceId) {
    const selected = selection.includes(id)

    return choices
        .map((c) => c.id)
        .filter((choice) => {
            if (selected) {
                return choice !== id && selection.includes(choice)
            } else {
                return choice === id || selection.includes(choice)
            }
        })
}
